<app-academic-headers></app-academic-headers>
<!-- <router-outlet></router-outlet> -->
<app-jee-mains-verification></app-jee-mains-verification>
<app-academic-footers></app-academic-footers>